export enum ActivitiesCategory {
    CALL = 'CALL',
    EMAIL = 'EMAIL',
    MEETING = 'MEETING',
    TASK = 'TASK'
}

export const ACTIVITIES_STYLES: Record<ActivitiesCategory, { color: string; icon: string }> = {
    [ActivitiesCategory.TASK]: { color: '#e32dc6', icon: 'pi pi-check' },
    [ActivitiesCategory.EMAIL]: { color: '#00bac1', icon: 'pi pi-envelope' },
    [ActivitiesCategory.MEETING]: { color: '#e1a21b', icon: 'pi pi-calendar' },
    [ActivitiesCategory.CALL]: { color: '#12ff7e', icon: 'pi pi-phone' },
};